import {
  withTranslation,
} from 'react-i18next';

import NotFoundSectionView from './NotFoundSectionView';

const TranslatedComponent = withTranslation()(NotFoundSectionView);

const Component = TranslatedComponent;

export default Component;
